var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 0 24)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "thumb-cuff",
    x: 2.5,
    y: 10.5,
    width: 3.5,
    height: 10.5,
    rx: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "thumb-hand",
    d: "M8.5 11 11.6 3.6c.3-.7 1.2-1 1.9-.6.9.5 1.3 1.5 1.1 2.5L14 9.5h4.6c1.3 0 2.3 1.2 2 2.5l-1.4 6.9c-.2 1.2-1.3 2.1-2.5 2.1H8.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDown);
export default __webpack_public_path__ + "static/media/thumb-down.babedc539e3c09564cac05a5d13d636a.svg";
export { ForwardRef as ReactComponent };